import { FilterType } from '../../../../../shared/enums/filter-type.enum'
import { ResourceSlug } from '../../../../../shared/enums/wordpress/wp-resource-slug.enum'
import { Filter } from '../../../../../shared/interfaces/filter.interface'

export const FilterGroups: {
  name?: string
  filters: Filter[]
  isHidden?: boolean
}[] = [
  {
    filters: [
      {
        title: 'Search',
        filterType: FilterType.TextInput,
        queryParam: 'terms',
        helpText: 'Search tools by name, concept, keyword, etc.',
        isOpen: true
      }
    ]
  },
  {
    filters: [
      {
        title: 'Target Sectors',
        slug: ResourceSlug.TargetSectors,
        filterType: FilterType.CheckBox,
        queryParam: 'targetSectorIds',
        relativeResourceObjectKey: 'targetSectors',
        isOpen: true
      }
    ]
  },

  {
    filters: [
      {
        title: 'Objective',
        slug: ResourceSlug.Objectives,
        filterType: FilterType.MultiTags,
        queryParam: 'objectiveIds',
        relativeResourceObjectKey: 'objectives',
        helpText: 'Objective of the metric',
        isOpen: true
      }
    ]
  },
  {
    filters: [
      {
        title: 'Purpose(s)',
        slug: ResourceSlug.Purposes,
        filterType: FilterType.CheckBox,
        queryParam: 'purposeIds',
        relativeResourceObjectKey: 'purposes',
        helpText: 'Purpose or action of the AI system'
      }
    ]
  }
]
